export { default } from './Modal.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Modal/Modal/index.js